module.exports = __webpack_public_path__ + "img/dj_black.fc8d98f1.jpg";